import * as React from 'react';
import './ArticleCta.scss';
import LinkButton from '../buttons/LinkButton';

const baseClass = 'article-cta';

type Props = {
    to?: string,
    label?: string
}

const ArticleCta: React.FunctionComponent<Props> = (props: Props) => {
    return <div className={baseClass}>
        <LinkButton to={props.to || '/'} label={props.label || 'Get Started'} />
    </div>
}
export default ArticleCta;
